import { remove as globalRemove, exists as globalExists } from 'utils/global';

/**
 * namespace
 */
export const _prefix = "__persistent__"

/**
 * @param {*} id 
 */
export const exists = (id) => {
    return globalExists(_prefix+id);
}

/**
 * 
 * @param {*} containerId 
 * @param {boolean} isStructured 
 * @param {boolean} isObject 
 */
export const get = (containerId, isStructured,isObject) => {
    isStructured = isStructured ? true : false;
    isObject = isObject==undefined ? true : isObject;
    
    var realId = _prefix+containerId;
    if(!globalExists(realId)){
        return isStructured ? false : "";
    }
    
    var obj = $("#"+realId)[0];
    if(!obj){
        return isStructured ? false : "";
    }
    
    if(!isStructured){
        return obj.innerHTML;
    }
    
    return getDatas(obj,isObject);
}

/**
 * 
 * @param {*} obj 
 * @param {boolean} isObject 
 */
export const getDatas = (obj, isObject) => {
    
    if(!obj){ 
        return false; 
    }
    
    var elements = $(obj).children();
    var datas = traverseToGet(elements);
    
    if (isObject){
        datas = $.extend({}, traverseToGet(elements));
    }
    
    return datas;

}

/**
 * 
 * @param {*} containerId 
 */
export const remove = (containerId) => {
    var realId = _prefix+containerId;
    globalRemove(realId);
}

/**
 * 
 * @param {*} containerId 
 * @param {*} elements 
 * @param {*} parentNode 
 * @param {*} noOverwrite 
 */
export const set = (containerId, elements, parentNode, noOverwrite) => {
    elements	= elements == undefined	? {} : elements;
    parentNode	= parentNode ? parentNode : $("body");
    noOverwrite	= noOverwrite ? true : false;
    
    var realId		= _prefix+containerId;
    var container	= null;
    
    
    if(!globalExists(realId)){
        parentNode.append('<div id="'+realId+'"></div>');
    } else if(noOverwrite) {
        return false;
    }
    
    
    container = $("#"+realId);
    container.hide();
    container.empty();
    
    if("object"==(typeof elements)){
        traverseToSet(elements, container);
    } else {
        container[0].innerHTML = elements;
    }
    
    return container;
}

/**
 * 
 * @param {*} elements 
 * @param {*} container 
 */
export const traverseToSet = (elements,container) => {
    
    var content = container;
    
    for(var elmt in elements){
        var field;
        
        if (typeof(elements[elmt])=="object") { 
            
            field	= isNaN(parseFloat(elmt)) ? 'field="'+elmt+'"' : '';
            content = $('<div '+field+' ></div>').appendTo(content);
            
            traverseToSet(elements[elmt], content); 
            
        } else {
            
            field	= isNaN(parseFloat(elmt)) ? 'field="'+elmt+'"' : '';
            content.append('<span '+field+'>'+(elements[elmt])+'</span>');
        }			
    }
}

/**
 * 
 * @param {*} elements 
 */
export const traverseToGet = (elements) => {
    
    var datas = new Array;
    
    for(var i=0; i<elements.length; i++){
        
        if(elements[i].tagName=='SPAN'){
            
            var value	= elements[i].innerHTML;
            var elmtName = (elements[i].getAttribute("field")) == null ? i : elements[i].getAttribute("field");

            var trimmed	= $.trim(value);
            
            if ((!isNaN(trimmed) && trimmed.length>0 && !(trimmed.length>3 && trimmed.charAt(0)=='0' ))){
                value = parseFloat(value);
            }
            
            datas[elmtName] = value;
            
        } else {
            
            if (elements[i].getAttribute("field") != null){
                
                datas[elements[i].getAttribute("field")] = traverseToGet($(elements[i]).children());
                
            } else {
                
                datas.push($.extend({}, traverseToGet($(elements[i]).children())));
                
            }
        
        }
        
    }

    return datas;
}